import { url } from '@ts/utils/url';

export const formatLinks = () => {
  const articleText = document.querySelector('.bo-article-text');
  const links = articleText?.getElementsByTagName('a');

  if (!links) return;

  Array.from(links).forEach(link => {
    // ignore link format if it is an abo breaker link button
    const aboButton = link.parentElement;
    if (aboButton?.parentElement?.className.includes('bc-abo-breaker__option'))
      return;

    link.classList.add('bo-link');

    const internalDomain = url.getDomain();

    const isInternalLink =
      (internalDomain && link.href.includes(internalDomain)) ||
      link.href.startsWith('/');

    if (!isInternalLink) {
      link.target = '_blank'; // Ensure all generic links opens in new tab
      link.classList.add('bo-link--external'); // Add external link icon
    }
  });
};
